import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SiteConfigFacade } from '@qwyk/portals/siteconfig';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class VerifyFeaturesGuard implements CanActivate, CanActivateChild {
    private features$ = this.siteConfig.features$;
    constructor(private siteConfig: SiteConfigFacade, private router: Router) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        // eslint-disable-next-line no-prototype-builtins
        if (!next.data || !next.data.hasOwnProperty('requiredFeature')) {
            return true;
        }
        const requiredFeature = next.data.requiredFeature;
        return this.features$.pipe(
            map(features => {
                const notAllowed = features[requiredFeature]?.value;
                if (notAllowed === true) {
                    this.redirect(next, 403, 'Forbidden');
                }
                return true;
            })
        );
    }

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.canActivate(next, state);
    }

    private redirect(next: ActivatedRouteSnapshot, errorCode, errorName): void {
        this.router.navigate([`/error/${errorCode}`], {
            queryParams: {
                source: next.pathFromRoot.map(p => p.url).join('/'),
                errorName,
            },
        });
    }
}
